import React from 'react';

export default function Footer() {
  return (
    <footer className='flex items-center bg-white h-[2.5rem] bottom-0 fixed border-t w-full'>
      <p className="p-3 tracking-widest text-start">
      {new Date().getFullYear()} <span className='font-sans'>&copy;</span> Copyrights - Xanadu
      </p>
    </footer>
  )
}